module.exports = __webpack_public_path__ + "img/when-house.44f038c6.png";